import { apiRequest } from "./common";

const  getProjectList = async () => {
    const response = await apiRequest('get', '/project-bank/list?page=1&limit=100');
    return response.data;
};

export {
    getProjectList
}